import findKey from 'lodash/findKey';

const codeMappings = {
  'cluey-kookaburra': {
    typeCode: 't-shirt',
    style: 'mens',
    deliveryDateCode: 'mens-t-shirts',
    ga: 'unisex-tshirt',
    ia: {
      code: 'u-tee-slim-crew',
      tagLinkSuffix: 't-shirts'
    }
  },
  'wonky-mozzie': {
    typeCode: 't-shirt',
    style: 'womens',
    deliveryDateCode: 'womens-t-shirts',
    ga: 'womens-tshirt',
    ia: {
      code: 'w-tee-slim-crew',
      tagLinkSuffix: 't-shirts'
    }
  },
  'fair-cuppa': {
    typeCode: 't-shirt',
    style: 'mhoodie',
    deliveryDateCode: 'mens-hoodies',
    ga: 'unisex-hoodie',
    ia: {
      code: 'u-sweatshirt-hooded',
      tagLinkSuffix: 'sweatshirts'
    }
  },
  'tall-larrikin': {
    typeCode: 't-shirt',
    style: 'tank',
    deliveryDateCode: 'unisex-tanks',
    ga: 'unisex-tank-top',
    ia: {
      code: 'u-tank-slim',
      tagLinkSuffix: 'tanks'
    }
  },
  'outback-brolly': {
    typeCode: 't-shirt',
    style: 'longsleeve',
    deliveryDateCode: 'mens-longsleeve-t-shirts',
    ga: 'unisex-longsleeve-tshirt',
    ia: {
      code: 'u-tee-slim-crew-long',
      tagLinkSuffix: 't-shirts'
    }
  },
  'shouty-pav': {
    typeCode: 't-shirt',
    style: 'racerback',
    deliveryDateCode: 'racerback-tanks',
    ga: 'womens-racerback',
    ia: {
      code: 'w-tank-racerback',
      tagLinkSuffix: 'womens-clothes'
    }
  },
  'jumping-boot': {
    typeCode: 't-shirt',
    style: 'pullover',
    deliveryDateCode: 'mens-sweatshirts',
    ga: 'unisex-sweatshirt',
    ia: {
      code: 'u-sweatshirt-pullover',
      tagLinkSuffix: 'sweatshirts'
    }
  },
  'grouse-chips': {
    typeCode: 't-shirt',
    style: 'raglan',
    deliveryDateCode: 'mens-baseball-sleeve-t-shirts',
    ga: 'unisex-baseball-sleeve-tshirt',
    ia: {
      code: 'u-tee-slim-crew-baseball',
      tagLinkSuffix: 't-shirts'
    }
  },
  'cheeky-cockatoo': {
    typeCode: 't-shirt',
    style: 'vneck',
    deliveryDateCode: 'mens-v-neck-t-shirts',
    ga: 'unisex-vneck-tshirt',
    ia: {
      code: 'u-tee-slim-vneck',
      tagLinkSuffix: 't-shirts'
    }
  },
  'dinkum-bandicoot': {
    typeCode: 'womens-fitted-scoop',
    deliveryDateCode: 'womens-fitted-scoops',
    ga: 'womens-fitted-scoop-tshirt',
    ia: {
      code: 'w-tee-slim-scoop',
      tagLinkSuffix: 't-shirts'
    }
  },
  'peckish-flannel': {
    typeCode: 'womens-fitted-v-neck',
    deliveryDateCode: 'womens-fitted-v-necks',
    ga: 'womens-fitted-vneck-tshirt',
    ia: {
      code: 'w-tee-slim-vneck',
      tagLinkSuffix: 't-shirts'
    }
  },
  'flaming-ute': {
    typeCode: 'womens-relaxed-fit',
    deliveryDateCode: 'womens-relaxed-fits',
    ga: 'womens-relaxed-fit-tshirt',
    ia: {
      code: 'w-tee-relaxed-crew',
      tagLinkSuffix: 't-shirts'
    }
  },
  'minty-fizzer': {
    typeCode: 'chiffon-top',
    deliveryDateCode: 'chiffon-tops',
    ga: 'chiffon-top',
    ia: {
      code: 'w-top-chiffon',
      tagLinkSuffix: 'womens-clothes'
    }
  },
  'beaut-razoo': {
    typeCode: 'contrast-tank',
    deliveryDateCode: 'contrast-tanks',
    ga: 'contrast-tank',
    ia: {
      code: 'w-tank-panel-contrast',
      tagLinkSuffix: 'womens-clothes'
    }
  },
  'cactus-bizzo': {
    typeCode: 'classic-tee',
    deliveryDateCode: 'classic-tees',
    ga: 'classic-tshirt',
    ia: {
      code: 'u-tee-regular-crew',
      tagLinkSuffix: 't-shirts'
    }
  },
  'unreal-chinwag': {
    typeCode: 'triblend-tee',
    deliveryDateCode: 'triblend-tees',
    ga: 'heather-tshirt',
    ia: {
      code: 'u-tee-triblend-slim-crew',
      tagLinkSuffix: 't-shirts'
    }
  },
  'ripper-rissole': {
    typeCode: 'mens-graphic-t-shirt',
    deliveryDateCode: 'mens-graphic-t-shirts',
    ga: 'mens-graphic-t-shirt',
    ia: {
      code: 'm-tee-panel-slim-crew',
      tagLinkSuffix: 't-shirts'
    }
  },
  'top-grub': {
    typeCode: 'long-t-shirt',
    deliveryDateCode: 'long-t-shirts',
    ga: 'long-t-shirt',
    ia: {
      code: 'u-tee-slim-longline',
      tagLinkSuffix: 't-shirts'
    }
  },
  'bonza-lamington': {
    typeCode: 't-shirt',
    style: 'mhoodiez',
    deliveryDateCode: 'zipper-hoodies',
    ga: 'unisex-zipper-hoodie',
    ia: {
      code: 'u-sweatshirt-zip-hooded',
      tagLinkSuffix: 'sweatshirts'
    }
  },
  'sooky-sanga': {
    typeCode: 'mens-premium-t-shirt',
    deliveryDateCode: 'mens-premium-t-shirts',
    ga: 'mens-premium-t-shirt',
    ia: {
      code: 'u-tee-premium-crew',
      tagLinkSuffix: 't-shirts'
    }
  },
  'googy-jaffle': {
    typeCode: 'womens-premium-t-shirt',
    deliveryDateCode: 'womens-premium-t-shirts',
    ga: 'womens-premium-t-shirt',
    ia: {
      code: 'w-tee-premium-crew',
      tagLinkSuffix: 't-shirts'
    }
  },
  'whinging-magpie': {
    typeCode: 'lightweight-hoodie',
    deliveryDateCode: 'lightweight-hoodies',
    ga: 'lightweight-hoodie',
    ia: {
      code: 'u-sweatshirt-lightweight-hooded',
      tagLinkSuffix: 'sweatshirts'
    }
  },
  'aggro-emu': {
    typeCode: 'lightweight-raglan-sweatshirt',
    deliveryDateCode: 'lightweight-raglan-sweatshirts',
    ga: 'lightweight-raglan-sweatshirt',
    ia: {
      code: 'u-sweatshirt-lightweight-raglan',
      tagLinkSuffix: 'sweatshirts'
    }
  },
  'shirty-shemozzle': {
    typeCode: 'graphic-t-shirt-dress',
    deliveryDateCode: 'graphic-t-shirt-dresses',
    ga: 'graphic-t-shirt-dress',
    ia: {
      code: 'w-dress-panel-tee',
      tagLinkSuffix: 'dresses'
    }
  },
  'dodgy-dooverlackie': {
    typeCode: 'a-line-dress',
    deliveryDateCode: 'a-line-dresses',
    ga: 'a-line-dress',
    ia: {
      code: 'w-dress-trapeze-a-line',
      tagLinkSuffix: 'dresses'
    }
  }
};

export const typeCodeFromProductTypeId = productTypeId => {
  if (!codeMappings[productTypeId]) return null;
  return codeMappings[productTypeId].typeCode;
};

export const styleFromProductTypeId = productTypeId => {
  if (!codeMappings[productTypeId]) return null;
  return codeMappings[productTypeId].style;
};

export const deliveryDateCodeFromProductTypeId = productTypeId => {
  if (!codeMappings[productTypeId]) return null;
  return codeMappings[productTypeId].deliveryDateCode;
};

export const iaCodeFromProductTypeId = productTypeId => {
  if (!codeMappings[productTypeId]) return null;
  return codeMappings[productTypeId].ia.code;
};

export const iaTagLinkSuffixFromProductTypeId = productTypeId => {
  if (!codeMappings[productTypeId]) return null;
  return codeMappings[productTypeId].ia.tagLinkSuffix;
};

export const gaCodeFromProductTypeId = productTypeId => {
  if (!codeMappings[productTypeId]) return null;
  return codeMappings[productTypeId].ga;
};

export const productTypeIdFromLegacyCodes = (typeCode, style) => {
  if (!typeCode) return null;

  if (style && style !== typeCode) {
    const key = findKey(codeMappings, { typeCode, style });
    if (key) return key;
  }

  return findKey(codeMappings, { typeCode });
};

export const PRODUCT_CATEGORIES = [
  'men-clothes',
  'women-clothes',
  'kids-clothes',
  'u-device-cases',
  'u-prints',
  'u-decor',
  'u-stationery',
  'u-bags'
];
